import AgencyService from './AgencyService';
import AgentService from './AgentService';
import BuyerService from './BuyerService';
import CallService from './CallService';
import LeadAgentService from './LeadAgentService';
import LeadService from './LeadService';
import NoteService from './NoteService';
import OutboundCommsService from './OutboundCommsService';
import PostcodeService from './PostcodeService';
import PropertyAddressService from './PropertyAddressService';
import PropertyService from './PropertyService';
import ReviewService from './ReviewService';
import SecurityService from './SecurityService';
import UserService from './UserService';
import ArticleService from './ArticleService';
import OaApiHandler from './OaApiHandler';
import AccountService from './AccountService';
import CaseService from './CaseService';
import OaApiService from './OaApiService';

const services = {
  handler: OaApiHandler,
  agency: new AgencyService(OaApiHandler),
  agent: new AgentService(OaApiHandler),
  buyer: new BuyerService(OaApiHandler),
  call: new CallService(OaApiHandler),
  leadAgent: new LeadAgentService(OaApiHandler),
  lead: new LeadService(OaApiHandler),
  note: new NoteService(OaApiHandler),
  outboundComms: new OutboundCommsService(OaApiHandler),
  postcode: new PostcodeService(OaApiHandler),
  propertyAddress: new PropertyAddressService(OaApiHandler),
  property: new PropertyService(OaApiHandler),
  review: new ReviewService(OaApiHandler),
  security: new SecurityService(OaApiHandler),
  user: new UserService(OaApiHandler),
  article: new ArticleService(OaApiHandler),
  account: new AccountService(OaApiHandler),
  case: new CaseService(OaApiHandler),
};

export default services;
